import React from 'react';
import { Toolbar, CardContent } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import { parseDate } from './CorporateKitsTable';
import BasicField from '../../basic/BasicField';
import CollectionItemHeader from '../../layout/CollectionItemHeader';
import AppLoader from '../../basic/AppLoader';
import { useItem } from '../../../hooks/atoms/item-hook';
import CollectionKeys from '../../../hooks/molecules/collection-keys';

const CorporateKitsDetails = ({ id }) => {
  const {
    item: kit,
    itemIsLoading,
    itemError,
  } = useItem(CollectionKeys.REGISTRATION_KITS, id);

  if (itemIsLoading) {
    return <AppLoader />;
  }

  if (itemError) {
    return <p>Error</p>;
  }

  const hasConsent = kit.agreements.find((aggr) => {
    return 'DOCTOR_GENERAL_CONSENT' === aggr?.consent?.name && true === aggr?.status;
  });

  return (
    <>
      <CollectionItemHeader
        subtitle={ `Created at: ${ kit?.serial_number_id?.created_at }` }
      />
      <Toolbar />
      <Grid container spacing={ 3 }>
        <Grid container item xs={ 12 } spacing={ 3 }>
          <Grid item xs={ 4 }>
            <Card style={ { width: '50vw' } }>
              <CardContent>
                <Grid item xs={ 12 }>
                  <BasicField
                    title='Serial Number'
                    field={ kit.serial_number_id.serial }
                    disabled
                  />
                  <BasicField
                    title='Brand Name'
                    field={ kit?.business?.brand_name }
                    disabled
                  />
                  <BasicField
                    title='Registration done date'
                    field={ parseDate(kit?.metadata?.registrationDoneDate) }
                    disabled
                  />
                  <BasicField
                    title='Sample received date'
                    field={ parseDate(kit?.metadata?.sampleReceivedDate) }
                    disabled
                  />
                  <BasicField
                    title='Patient Last Name'
                    field={ kit.customer_id?.family_name }
                    disabled
                  />
                  <BasicField
                    title='Patient First Name'
                    field={ kit.customer_id?.name }
                    disabled
                  />
                  <BasicField
                    title='Registration Status'
                    field={ kit.registrationStatus }
                    disabled
                  />
                  <BasicField
                    title='Payment Status'
                    field={ kit?.metadata?.cashStatus }
                    disabled
                  />
                  <BasicField
                    title='Payment Amount'
                    field={ kit?.metadata?.cashAmount }
                    disabled
                  />
                  <BasicField
                    title='Sample collection date'
                    field={ kit?.metadata?.sampleCollectionDate }
                    disabled
                  />
                  <BasicField
                    title='Description'
                    field={ kit.serial_number_id?.metadata?.['Product Description'] }
                    disabled
                  />

                  <BasicField
                    title='Processing of personal data'
                    field={ hasConsent ? 'YES' : 'NO' }
                    disabled
                  />
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default CorporateKitsDetails;
